import { render, staticRenderFns } from "./jobsFailed.vue?vue&type=template&id=15b46772&scoped=true&"
import script from "./jobsFailed.vue?vue&type=script&lang=js&"
export * from "./jobsFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b46772",
  null
  
)

export default component.exports